import router from '@/router/index'
import axios from 'axios'
import qs from 'qs'
import { getStorage, removeStorage } from './auth'

var domain = document.domain;
var prodomain = '';
var apiDomain = process.env.BASE_API;

console.dir(apiDomain);

// 唐吉后台
// dev https://apidev.interhouse.cn => https://lapi.interhouse.cn/dev/bim/ https://lapi.interhouse.cn/dev/mall/
// test https://apitest.interhouse.cn => https://lapi.interhouse.cn/test/bim/ https://lapi.interhouse.cn/test/mall/
// stage https://apistage.interhouse.cn => https://api2.interhouse.cn/stage/bim/ https://api2.interhouse.cn/stage/mall/
// online https://api.interhouse.cn => https://api2.interhouse.cn/bim/ https://api2.interhouse.cn/mall/
switch (domain) {
  case 'localhost':
    apiDomain = 'https://lapi.interhouse.cn/local/bim';
    prodomain = '/bim';
    break;
  case 'tjdev.interhouse.cn':
    apiDomain = 'https://lapi.interhouse.cn/dev/bim';
    prodomain = '/bim';
    break;
  case 'tjtest.interhouse.cn':
    apiDomain = 'https://lapi.interhouse.cn/test/bim';
    prodomain = '/bim';
    break;
  case 'tjstage.interhouse.cn':
    apiDomain = 'https://api2.interhouse.cn/stage/bim';
    prodomain = '/bim';
    break;
  case 'tj.interhouse.cn':
    apiDomain = 'https://api2.interhouse.cn/bim';
    prodomain = '/bim';
    break;
  default:
    apiDomain = 'https://api2.interhouse.cn/bim';
    prodomain = '/bim';
    break;
}
// switch (domain) {
//   case 'localhost':
//     apiDomain = 'https://lapi.interhouse.cn/dev/lmall';
//     prodomain = '/lmall';
//     break;
//   case 'tjdev.interhouse.cn':
//     apiDomain = 'https://lapi.interhouse.cn/dev/lmall';
//     prodomain = '/lmall';
//     break;
//   case 'tjtest.interhouse.cn':
//     apiDomain = 'https://lapi.interhouse.cn/test/lmall';
//     prodomain = '/lmall';
//     break;
//   case 'tjstage.interhouse.cn':
//     apiDomain = 'https://api2.interhouse.cn/stage/lmall';
//     prodomain = '/lmall';
//     break;
//   case 'tj.interhouse.cn':
//     apiDomain = 'https://api2.interhouse.cn/lmall';
//     prodomain = '/lmall';
//     break;
//   default:
//     apiDomain = 'https://api2.interhouse.cn/lmall';
//     prodomain = '/lmall';
//     break;
// }
let prodomainType = JSON.parse(JSON.stringify(prodomain));
prodomain = document.location.origin + prodomain;
apiDomain = prodomain;
window.apiDomain = prodomain;
// 创建axios实例
const service = axios.create({
  baseURL: prodomain, // api的base_url multipart/form-data
  // timeout: 5000, // 请求超时时间
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded/multipart/form-data;charset=UTF-8'
  }
})

// request拦截器
service.interceptors.request.use(config => {
  config.baseURL = config.data.microservices ? `/${config.data.microservices}/` : '/mall/';
  // 唐吉e购相关接口改变地址
  if (router.currentRoute.meta.type && (router.currentRoute.meta.type == 'store') && (config.data.service !== 'User.Login.GetUserInfo') && (config.data.service != 'App.Oss.GetUploadId') && (config.data.service != 'App.Oss.CompleteUpload') && (config.data.service != 'User.Auth.Logout')) {
    // config.baseURL = document.location.origin + '/mall/';
    config.baseURL = config.data.microservices ? `/${config.data.microservices}/` : '/mall/';
  } else {
    config.baseURL = config.data.microservices ? `/${config.data.microservices}/` : '/bim/'
  }
  if (router.currentRoute.meta.type && (router.currentRoute.meta.type == 'storeOrbim') && (config.data.service !== 'User.Login.GetUserInfo') && (config.data.service != 'App.Oss.GetUploadId') && (config.data.service != 'App.Oss.CompleteUpload') && (config.data.service != 'User.Auth.Logout')) {
    // config.baseURL = document.location.origin + '/mall/';
    config.baseURL = config.data.microservices ? `/${config.data.microservices}/` : '/mall/';
    let data = qs.stringify(config.data)
    if (data.indexOf('Pc.Product_Category_Main.GetList') != -1) {
      config.baseURL = config.data.microservices ? `/${config.data.microservices}/` : '/mall/';
    } else {
      config.baseURL = config.data.microservices ? `/${config.data.microservices}/` : '/bim/'
    }
  }
  config.headers['Authorization'] = getStorage('token');
  // Do something before request is sentd
  if (config.method === 'post') {
    config.data = qs.stringify(config.data);
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
  }
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(response => {
  //respone 禁止谷歌浏览器 缓存 登录的账号和密码
  response.headers["Cache-Control"] = "no-cache"
  response.headers["Pragma"] = "no-cache"
  response.headers["Expires"] = "-1"
  if (response) {

    if (response.data.ret == "10101") { //token失效码
      removeStorage("token");
      removeStorage("uid");
      router.replace({
        path: '/',
        query:
        {
          redirect: router.currentRoute.fullPath
        }
      });
      router.push('/')

    }
  }
  return response
}, error => {
  if (error.response.status == 401) {
    removeStorage("token");
    removeStorage("uid");
    router.replace({
      path: '/',
      query:
      {
        redirect: router.currentRoute.fullPath
      }
    });
    router.push('/')
  } else {
    if (('' + error).indexOf('499') > 0) {
      removeStorage()
      router.push('/login')
    }

    console.log('err' + error)// for debug
    return Promise.reject(error)
  }

}
)

export default service;
export { apiDomain };

// WEBPACK FOOTER //
// ./src/utils/fetch.js



// WEBPACK FOOTER //
// ./src/service/fetch.js